import * as React from 'react';
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {handleScrollIntoView, removeNonNumeric} from "../assets/js/main";
import {Autocomplete, Checkbox, CircularProgress, FormControlLabel, FormGroup, Radio, RadioGroup, Stack, Switch, TextField, Typography, Divider, Box} from "@mui/material";
import NavBar from "../components/NavBar";
import {setLoading} from "../redux/loading/actions";
import {useSnackbar} from "notistack";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import {Clear, Payment} from "@mui/icons-material";
import HandleFetchData from "../plugin/HandleFetchData";
import {PatternFormat} from "react-number-format";
import DateObject from "react-date-object";
import gregorian from "react-date-object/calendars/gregorian";
import gregorian_en from "react-date-object/locales/gregorian_en";

export default function AgencyRequest(props) {
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const selector = useSelector((st) => st)
  const {enqueueSnackbar} = useSnackbar();
  const {fetchData} = HandleFetchData()

  const ref1 = React.useRef()
  const ref2 = React.useRef()
  const ref3 = React.useRef()
  const ref4 = React.useRef()
  const ref5 = React.useRef()
  const ref6 = React.useRef()
  const ref7 = React.useRef()
  const ref8 = React.useRef()
  const ref9 = React.useRef()
  const ref10 = React.useRef()
  const ref11 = React.useRef()
  const ref12 = React.useRef()
  const ref13 = React.useRef()
  const ref14 = React.useRef()
  const ref15 = React.useRef()
  const ref16 = React.useRef()
  const ref17 = React.useRef()
  const ref18 = React.useRef()
  const ref19 = React.useRef()
  const ref20 = React.useRef()
  const ref21 = React.useRef()
  const ref22 = React.useRef()
  const ref23 = React.useRef()
  const ref24 = React.useRef()
  const ref25 = React.useRef()
  const ref26 = React.useRef()
  const ref27 = React.useRef()
  const ref28 = React.useRef()
  const ref29 = React.useRef()
  const ref30 = React.useRef()
  const ref31 = React.useRef()

  const [shopName, setShopName] = React.useState('');
  const [firstName, setFirstName] = React.useState('');
  const [lastName, setLastName] = React.useState('');
  const [father, setFather] = React.useState('');
  const [birthCertificateNo, setBirthCertificateNo] = React.useState('');
  const [birthSerialNo, setBirthSerialNo] = React.useState('');
  const [birthCertificateSeries, setBirthCertificateSeries] = React.useState('');
  const [listStateAndCity, setListStateAndCity] = React.useState([])
  const [textStateAndCity, setTextStateAndCity] = React.useState('')
  const [newStateAndCity, setNewStateAndCity] = React.useState(null)
  const [textStateAndCityHome, setTextStateAndCityHome] = React.useState('')
  const [newStateAndCityHome, setNewStateAndCityHome] = React.useState(null)
  const [birthDate, setBirthDate] = React.useState(null)
  const [nationalCode, setNationalCode] = React.useState('');
  const [nationalCodeSerial, setNationalCodeSerial] = React.useState('');
  const [gender, setGender] = React.useState("");

  const [address, setAddress] = React.useState('');
  const [postalCode, setPostalCode] = React.useState('');
  const [mobileNo, setMobileNo] = React.useState('');
  const [phoneNo, setPhoneNo] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [married, setMarried] = React.useState('');

  const [addressAgent, setAddressAgent] = React.useState('');
  const [postalCodeAgent, setPostalCodeAgent] = React.useState('');
  const [phoneNoAgent, setPhoneNoAgent] = React.useState('');
  const [textStateAndCityAgent, setTextStateAndCityAgent] = React.useState('')
  const [newStateAndCityAgent, setNewStateAndCityAgent] = React.useState(null)

  const [accountNo, setAccountNo] = React.useState('');
  const [ibanNumber, setIbanNumber] = React.useState('');
  const [branchName, setBranchName] = React.useState('');
  const [bank, setBank] = React.useState('');
  const [desc, setDesc] = React.useState('');
  const [postalRecords, setPostalRecords] = React.useState('');
  const [acquaintance, setAcquaintance] = React.useState('');
  const [fleetCapacity, setFleetCapacity] = React.useState('');
  const [job, setJob] = React.useState(false);
  const [rules, setRules] = React.useState(false);
  const [request, setRequest] = React.useState(true);

  const [banks, setBanks] = React.useState([]);
  const [acquaintances, setAcquaintances] = React.useState([]);

  const [validations, setValidations] = React.useState({});

  React.useEffect(() => {
    handleGetBanks()
    handleGetAcquaintances()
    getStateAndCity()
  },[])

  const validationInput = () => {
    if(!request && !shopName){
      handleScrollIntoView(ref1)
      setValidations({
        shopName: 'نام فروشگاه الزامی می باشد'
      })
    }else if(!firstName){
      handleScrollIntoView(ref2)
      setValidations({
        firstName: 'نام الزامی می باشد'
      })
    }else if(!lastName){
      handleScrollIntoView(ref3)
      setValidations({
        lastName: 'نام خانوادگی الزامی می باشد'
      })
    }else if(!father){
      handleScrollIntoView(ref4)
      setValidations({
        father: 'نام پدر الزامی می باشد'
      })
    }else if(!mobileNo){
      handleScrollIntoView(ref12)
      setValidations({
        mobileNo: 'شماره همراه الزامی می باشد'
      })
    }else if(!birthCertificateNo){
      handleScrollIntoView(ref5)
      setValidations({
        birthCertificateNo: 'شماره شناسنامه الزامی می باشد'
      })
    }else if(!birthSerialNo){
      handleScrollIntoView(ref6)
      setValidations({
        birthSerialNo: 'سریال شناسنامه الزامی می باشد'
      })
    }else if(!birthCertificateSeries){
      handleScrollIntoView(ref7)
      setValidations({
        birthCertificateSeries: 'سری شناسنامه الزامی می باشد'
      })
    }else if(!newStateAndCity){
      handleScrollIntoView(ref8)
      setValidations({
        newStateAndCity: 'محل صدور الزامی می باشد'
      })
    }else if(!birthDate){
      handleScrollIntoView(ref9)
      setValidations({
        birthDate: 'تاریخ تولد الزامی می باشد'
      })
    }else if(!nationalCode){
      handleScrollIntoView(ref10)
      setValidations({
        nationalCode: 'کدملی الزامی می باشد'
      })
    }else if(!nationalCodeSerial){
      handleScrollIntoView(ref11)
      setValidations({
        nationalCodeSerial: 'سریال کارت ملی الزامی می باشد'
      })
    }else if(!married){
      handleScrollIntoView(ref17)
      setValidations({
        married: 'وضعیت تاهل الزامی می باشد'
      })
    }else if(!gender){
      handleScrollIntoView(ref18)
      setValidations({
        gender: 'جنسیت الزامی می باشد'
      })
    }else if(!newStateAndCityHome){
      handleScrollIntoView(ref13)
      setValidations({
        newStateAndCityHome: 'استان/شهر محل سکونت الزامی می باشد'
      })
    }else if(!address){
      handleScrollIntoView(ref14)
      setValidations({
        address: 'آدرس محل سکونت الزامی می باشد'
      })
    }else if(!postalCode){
      handleScrollIntoView(ref15)
      setValidations({
        postalCode: 'کدپستی محل سکونت الزامی می باشد'
      })
    }else if(!phoneNo){
      handleScrollIntoView(ref16)
      setValidations({
        phoneNo: 'تلفن محل سکونت الزامی می باشد'
      })
    }else if(!newStateAndCityAgent){
      handleScrollIntoView(ref19)
      setValidations({
        newStateAndCityAgent: 'استان/شهر محل نمایندگی الزامی می باشد'
      })
    }else if(!addressAgent){
      handleScrollIntoView(ref20)
      setValidations({
        addressAgent: 'آدرس محل نمایندگی الزامی می باشد'
      })
    }else if(!postalCodeAgent){
      handleScrollIntoView(ref21)
      setValidations({
        postalCodeAgent: 'کدپستی محل نمایندگی الزامی می باشد'
      })
    }else if(!phoneNoAgent){
      handleScrollIntoView(ref22)
      setValidations({
        phoneNoAgent: 'تلفن محل نمایندگی الزامی می باشد'
      })
    }else if(!accountNo){
      handleScrollIntoView(ref23)
      setValidations({
        accountNo: 'شماره حساب الزامی می باشد'
      })
    }else if(!ibanNumber){
      handleScrollIntoView(ref24)
      setValidations({
        ibanNumber: 'شماره شبا الزامی می باشد'
      })
    }else if(!bank){
      handleScrollIntoView(ref25)
      setValidations({
        bank: 'بانک الزامی می باشد'
      })
    }else if(!branchName){
      handleScrollIntoView(ref26)
      setValidations({
        branchName: 'شعبه بانک الزامی می باشد'
      })
    }else if(!postalRecords){
      handleScrollIntoView(ref27)
      setValidations({
        postalRecords: 'سوابق پستی الزامی می باشد'
      })
    }
    // else if(!acquaintance){
    //   handleScrollIntoView(ref28)
    //   setValidations({
    //     acquaintance: 'نحوه آشنایی الزامی می باشد'
    //   })
    // }
    else if(!fleetCapacity){
      handleScrollIntoView(ref29)
      setValidations({
        fleetCapacity: 'ظرفیت ناوگان الزامی می باشد'
      })
    }else if(!desc){
      handleScrollIntoView(ref30)
      setValidations({
        desc: 'توضیحات الزامی می باشد'
      })
    }else if(!rules){
      handleScrollIntoView(ref31)
      setValidations({
        rules: 'قوانین الزامی می باشد'
      })
    }else{
      handleAddAgent()
    }
  }

  // متد دریافت لیست استان ها
  const getStateAndCity = async (e) => {
    dispatch(setLoading(true))
    let fetch = await fetchData('nbl', 'GET', `/v1/Address/getStateCity`, '', "application/json", {
      "term": e
    }, 'postex')
    setListStateAndCity(fetch?.data)
    dispatch(setLoading(false))
  }

  const handleGetBanks = async () => {
    dispatch(setLoading(true))
    let fetch = await fetchData('api.panel', 'GET', '/v1/Banks', '',"application/json", {}, 'postex', "HiBackOfficePostexAdmin@1402")

    // console.log('fetch', fetch)
    if(fetch?.success){
      setBanks(fetch?.data)
    }
    dispatch(setLoading(false))
  }

  const handleGetAcquaintances = async () => {
    dispatch(setLoading(true))
    let fetch = await fetchData('api.panel', 'GET', '/v1/Constants/HowToKnows', '',"application/json", {}, 'postex', "HiBackOfficePostexAdmin@1402")

    // console.log('fetch', fetch)
    if(fetch?.success){
      setAcquaintances(fetch?.data)
    }
    dispatch(setLoading(false))
  }

  const handleAddAgent = async (e) => {
    dispatch(setLoading(true))
    let fetch = await fetchData('api.panel', 'POST', '/v1/Agents', {
         "id": 0,
         "shopName": shopName,
         "firstName": firstName,
         "lastName": lastName,
         "fatherName": father,
         "birthCertificateNumber": birthCertificateNo,
         "birthCertificateSerial": birthSerialNo,
         "birthCertificateSeri": birthCertificateSeries,
         "birthCertificateIssuedCityId": Number(newStateAndCity?.id?.split('-')[1]),
         "birthDate": birthDate ? new DateObject(birthDate).convert(gregorian, gregorian_en).format("YYYY-MM-DDThh:mm:ss") : "",
         "nationalId": nationalCode,
         "nationalCardSerial": nationalCodeSerial,
         "gender": Number(gender)+1,
         "email": email,
         "homeCityId": Number(newStateAndCityHome?.id?.split('-')[1]),
         "homeAddress": address,
         "homePostalCode": postalCode,
         "homePhoneNumber": phoneNo,
         "mobile": mobileNo,
         "cityId": Number(newStateAndCityAgent?.id?.split('-')[1]),
         "address": addressAgent,
         "postalCode": postalCodeAgent,
         "phoneNumber": phoneNoAgent,
         "sheba": "IR"+ibanNumber,
         "bankAccountNumber": accountNo,
         "bankId": Number(bank),
         "bankBranchName": branchName,
         "isShop": !request,
         "websiteUrl": "",
         "postHistoryJob": postalRecords,
         "howToNow": Number(acquaintance),
         "isMarried": Boolean(married),
         "capacity": Number(fleetCapacity),
         "haveSecondJob": job,
         "description": desc
       },
       "application/json", '', 'postex', "HiBackOfficePostexAdmin@1402"
    )

    console.log('fetch', fetch)

    if (fetch?.success) {
      window.location.reload();

      enqueueSnackbar(fetch?.message, {
        variant: 'success',
        TransitionProps: {
          direction: 'down',
        },
        anchorOrigin: {
          horizontal: 'center',
          vertical: 'top'
        }
      })
    }
    dispatch(setLoading(false))
  }

  return (
     <>
       <NavBar blue back/>

       <div className="container">
         <div className="agencyRequestPage">
           <div className="titlePage">
             <h1>{t("agencyRequest.t1")}</h1>
             <p>{t("agencyRequest.t2")}</p>
           </div>
           <div className="form">

             <div className="row">
               <div className="col-12 col-md-6 col-lg-4 d-flex justify-content-center align-items-center">
                 <Stack direction="row" spacing={1} alignItems="center">
                   <Typography>{t("agencyRequest.t48")}</Typography>
                   <Switch checked={request} onChange={(e) => setRequest(e.target.checked)} color="default"/>
                   <Typography>{t("agencyRequest.t49")}</Typography>
                 </Stack>
               </div>

               {!request && <div className="col-12 col-md-6 col-lg-4">
                 <div className="input">
                   <label>{t("agencyRequest.t50")}</label>
                   <input type="text" name="shopName" id="shopName" ref={ref1}
                          value={shopName}
                          onChange={e => setShopName(e.target.value)}/>
                   {
                     validations?.shopName &&
                     <p className="error">{validations?.shopName}</p>
                   }
                 </div>
               </div>
               }

             </div>

             <div className="row">
               <div className="col-12">
                 <h5>{t("agencyRequest.t52")}:</h5>
               </div>
               <div className="col-12 col-md-6 col-lg-4">
                 <div className="input">
                   <label>{t("agencyRequest.t3")}</label>
                   <input type="text" name="firstName" id="firstName" ref={ref2}
                          value={firstName}
                          onChange={e => setFirstName(e.target.value)}/>
                   {
                     validations?.firstName &&
                     <p className="error">{validations?.firstName}</p>
                   }
                 </div>
               </div>
               <div className="col-12 col-md-6 col-lg-4">
                 <div className="input">
                   <label>{t("agencyRequest.t51")}</label>
                   <input type="text" name="lastName" id="lastName" ref={ref3}
                          value={lastName}
                          onChange={e => setLastName(e.target.value)}/>
                   {
                     validations?.lastName &&
                     <p className="error">{validations?.lastName}</p>
                   }
                 </div>
               </div>
               <div className="col-12 col-md-6 col-lg-4">
                 <div className="input">
                   <label>{t("agencyRequest.t53")}</label>
                   <input type="text" name="father" id="father" ref={ref4}
                          value={father}
                          onChange={e => setFather(e.target.value)}/>
                   {
                     validations?.father &&
                     <p className="error">{validations?.father}</p>
                   }
                 </div>
               </div>
               <div className="col-12 col-md-6 col-lg-4">
                 <div className="input">
                   <label>{t("agencyRequest.t8")}</label>
                   <input type="text" name="mobileNo" className="numeric" inputMode='numeric' id="mobileNo"
                          value={mobileNo} ref={ref5}
                          onChange={e =>  e?.target?.value?.length <= 11 && setMobileNo(removeNonNumeric(e.target.value))}/>
                   {
                     validations?.mobileNo &&
                     <p className="error">{validations?.mobileNo}</p>
                   }
                 </div>
               </div>
               <div className="col-12 col-md-6 col-lg-4">
                 <div className="input">
                   <label>{t("agencyRequest.t54")}</label>
                   <input type="text" name="birthCertificateNo" className="numeric" inputMode='numeric' id="birthCertificateNo" ref={ref6}
                          value={birthCertificateNo}
                          onChange={e => setBirthCertificateNo(removeNonNumeric(e.target.value))}/>
                   {
                     validations?.birthCertificateNo &&
                     <p className="error">{validations?.birthCertificateNo}</p>
                   }
                 </div>
               </div>
               <div className="col-12 col-md-6 col-lg-4">
                 <div className="row">
                   <div className="col-6">
                     <div className="input">
                       <label>{t("agencyRequest.t55")}</label>
                       <input type="text" name="birthSerialNo" className="numeric" inputMode='numeric' id="birthSerialNo" ref={ref7}
                              value={birthSerialNo}
                              onChange={e => e?.target?.value?.length <= 6 && setBirthSerialNo(removeNonNumeric(e.target.value))}/>
                       {
                         validations?.birthSerialNo &&
                         <p className="error">{validations?.birthSerialNo}</p>
                       }
                     </div>
                   </div>
                   <div className="col slash">/</div>
                   <div className="col-5">
                     <div className="input">
                       <label>{t("agencyRequest.t56")}</label>
                       <input type="text" name="birthCertificateSeries" id="birthCertificateSeries"
                              value={birthCertificateSeries} ref={ref8}
                              onChange={e => e?.target?.value?.length <= 3 && setBirthCertificateSeries(e.target.value)}/>
                       {
                         validations?.birthCertificateSeries &&
                         <p className="error">{validations?.birthCertificateSeries}</p>
                       }
                     </div>
                   </div>
                 </div>
               </div>
               <div className="col-12 col-md-6 col-lg-4">
                 <div className="input mb-3">
                   <label>{t("agencyRequest.t57")}</label>
                   <Autocomplete
                      ref={ref9}
                      inputValue={textStateAndCity}
                      noOptionsText={t("autoComplete.t1")}
                      id="stateAndCity"
                      disablePortal
                      autoHighlight
                      loading={selector?.loading?.isLoading}
                      onChange={(e, value, reason) => {
                        if (reason === 'clear') {
                          setTextStateAndCity('')
                          setNewStateAndCity(null)
                        } else {
                          setTextStateAndCity(value?.name)
                          setNewStateAndCity(value)
                        }
                      }}
                      options={listStateAndCity || []}
                      getOptionLabel={(option) => option?.name}
                      renderInput={(params) =>
                         <TextField {...params}
                                    hiddenLabel
                                    size="small"
                                    placeholder={t("singleOrder.sender.t28")}
                                    onChange={(event) => {
                                      setTextStateAndCity(event?.target?.value)
                                      event?.target?.value?.length > 2 && getStateAndCity(event?.target?.value)
                                    }}
                                    InputProps={{
                                      ...params.InputProps,
                                      endAdornment: (
                                         <React.Fragment>
                                           {selector?.loading?.isLoading ? <CircularProgress style={{margin: '0 5px'}} size={20}/> : null}
                                           {params.InputProps.endAdornment}
                                         </React.Fragment>
                                      ),
                                    }}
                         />}
                   />
                   {
                     validations?.newStateAndCity &&
                     <p className="error">{validations?.newStateAndCity}</p>
                   }
                 </div>
               </div>
               <div className="col-12 col-md-6 col-lg-4">
                 <div className="input">
                   <label className="">{t("codRequest.t7")}</label>
                   <div className="date-picker" ref={ref10}>
                     <DatePicker
                        id="setBirthDate"
                        calendar={persian}
                        locale={persian_fa}
                        value={birthDate}
                        onChange={e => setBirthDate(e)}
                     />
                     <button type="button" onClick={() => setBirthDate(null)} id="toDate">
                       <Clear/>
                     </button>
                   </div>
                   {
                     validations?.birthDate &&
                     <p className="error">{validations?.birthDate}</p>
                   }
                 </div>
               </div>
               <div className="col-12 col-md-6 col-lg-4">
                 <div className="input">
                   <label>{t("agencyRequest.t59")}</label>
                   <input type="text" name="nationalCode" id="nationalCode" ref={ref11} className="numeric" onChange={(e) => e.target.value.length <= 10 && setNationalCode(removeNonNumeric(e.target.value))}
                          value={nationalCode}/>
                   {
                     validations?.nationalCode &&
                     <p className="error">{validations?.nationalCode}</p>
                   }
                 </div>
               </div>
               <div className="col-12 col-md-6 col-lg-4">
                 <div className="input">
                   <label>{t("agencyRequest.t60")}</label>
                   <input type="text" name="nationalCardSerial" ref={ref12} id="nationalCardSerial" onChange={(e) => e.target.value.length <= 10 && setNationalCodeSerial(e.target.value)}
                          value={nationalCodeSerial}/>
                   {
                     validations?.nationalCodeSerial &&
                     <p className="error">{validations?.nationalCodeSerial}</p>
                   }
                 </div>
               </div>
               <div className="col-12 col-md-6 col-lg-4">
                 <div className="input">
                   <label>{t("agencyRequest.t9")}</label>
                   <input type="email" name="email" id="email"
                          value={email}
                          onChange={e => setEmail(e.target.value)}/>

                 </div>
               </div>
               <div className="col-12 col-md-6 col-lg-4">
                 <div className="input">
                   <label>{t("agencyRequest.t10")}</label>
                   <RadioGroup
                      ref={ref13}
                      row
                      aria-labelledby="demo-radio-buttons-group-label"
                      defaultValue="0"
                      name="radio-buttons-group"
                      value={married}
                      onChange={(e) => setMarried(e.target.value)}
                   >
                     <FormControlLabel value="0" control={<Radio/>} label={t("agencyRequest.t11")}/>
                     <FormControlLabel value="1" control={<Radio/>} label={t("agencyRequest.t12")}/>
                   </RadioGroup>
                   {
                     validations?.married &&
                     <p className="error">{validations?.married}</p>
                   }
                 </div>
               </div>
               <div className="col-12 col-md-6 col-lg-4">
                 <label>{t("agencyRequest.t61")}</label>
                 <RadioGroup
                    ref={ref14}
                    row
                    aria-labelledby="demo-radio-buttons-group-label"
                    defaultValue="0"
                    name="radio-buttons-group"
                    value={gender}
                    onChange={(e) => setGender(e.target.value)}
                 >
                   <FormControlLabel value="0" control={<Radio/>} label={t("agencyRequest.t62")}/>
                   <FormControlLabel value="1" control={<Radio/>} label={t("agencyRequest.t63")}/>
                 </RadioGroup>
                 {
                   validations?.gender &&
                   <p className="error">{validations?.gender}</p>
                 }
               </div>

               <Divider />

               <div className="col-12">
                 <h5>{t("agencyRequest.t64")}:</h5>
               </div>
               <div className="col-12 col-md-4">
                 <div className="input mb-3">
                   <label>{t("agencyRequest.t4")}</label>
                   <Autocomplete
                      ref={ref15}
                      inputValue={textStateAndCityHome}
                      noOptionsText={t("autoComplete.t1")}
                      id="stateAndCity"
                      disablePortal
                      autoHighlight
                      loading={selector?.loading?.isLoading}
                      onChange={(e, value, reason) => {
                        if (reason === 'clear') {
                          setTextStateAndCityHome('')
                          setNewStateAndCityHome(null)
                        } else {
                          setTextStateAndCityHome(value?.name)
                          setNewStateAndCityHome(value)
                        }
                      }}
                      options={listStateAndCity || []}
                      getOptionLabel={(option) => option?.name}
                      renderInput={(params) =>
                         <TextField {...params}
                                    hiddenLabel
                                    size="small"
                                    placeholder={t("singleOrder.sender.t28")}
                                    onChange={(event) => {
                                      setTextStateAndCityHome(event?.target?.value)
                                      event?.target?.value?.length > 2 && getStateAndCity(event?.target?.value)
                                    }}
                                    InputProps={{
                                      ...params.InputProps,
                                      endAdornment: (
                                         <React.Fragment>
                                           {selector?.loading?.isLoading ? <CircularProgress style={{margin: '0 5px'}} size={20}/> : null}
                                           {params.InputProps.endAdornment}
                                         </React.Fragment>
                                      ),
                                    }}
                         />}
                   />
                   {
                     validations?.newStateAndCityHome &&
                     <p className="error">{validations?.newStateAndCityHome}</p>
                   }
                 </div>
               </div>
               <div className="col-12 col-md-8">
                 <div className="input">
                   <label>{t("agencyRequest.t5")}</label>
                   <input type="text" name="address" id="address"
                          value={address} ref={ref16}
                          onChange={e => setAddress(e.target.value)}/>
                   {
                     validations?.address &&
                     <p className="error">{validations?.address}</p>
                   }
                 </div>
               </div>
               <div className="col-12 col-md-6 col-lg-4">
                 <div className="input">
                   <label>{t("agencyRequest.t65")}</label>
                   <input type="text" name="postalCode" className="numeric"
                          value={postalCode} id="postalCode" ref={ref17}
                          onChange={e => e?.target?.value?.length <= 10 && setPostalCode(removeNonNumeric(e.target.value))}
                   />
                   {
                     validations?.postalCode &&
                     <p className="error">{validations?.postalCode}</p>
                   }
                 </div>
               </div>
               <div className="col-12 col-md-6 col-lg-4">
                 <div className="input">
                   <label>{t("agencyRequest.t7")}</label>
                   <input type="text" name="phoneNo" className="numeric" inputMode='numeric' id="phoneNo"
                          value={phoneNo} ref={ref18}
                          onChange={e => e?.target?.value?.length <= 11 && setPhoneNo(removeNonNumeric(e.target.value))}/>
                   {
                     validations?.phoneNo &&
                     <p className="error">{validations?.phoneNo}</p>
                   }
                 </div>
               </div>

               <Divider />

               <div className="col-12">
                 <h5>{t("agencyRequest.t66")}:</h5>
               </div>
               <div className="col-12 col-md-4">
                 <div className="input mb-3">
                   <label>{t("agencyRequest.t4")}</label>
                   <Autocomplete
                      ref={ref19}
                      inputValue={textStateAndCityAgent}
                      noOptionsText={t("autoComplete.t1")}
                      id="stateAndCityAgent"
                      disablePortal
                      autoHighlight
                      loading={selector?.loading?.isLoading}
                      onChange={(e, value, reason) => {
                        if (reason === 'clear') {
                          setTextStateAndCityAgent('')
                          setNewStateAndCityAgent(null)
                        } else {
                          setTextStateAndCityAgent(value?.name)
                          setNewStateAndCityAgent(value)
                        }
                      }}
                      options={listStateAndCity || []}
                      getOptionLabel={(option) => option?.name}
                      renderInput={(params) =>
                         <TextField {...params}
                                    hiddenLabel
                                    size="small"
                                    placeholder={t("singleOrder.sender.t28")}
                                    onChange={(event) => {
                                      setTextStateAndCityAgent(event?.target?.value)
                                      event?.target?.value?.length > 2 && getStateAndCity(event?.target?.value)
                                    }}
                                    InputProps={{
                                      ...params.InputProps,
                                      endAdornment: (
                                         <React.Fragment>
                                           {selector?.loading?.isLoading ? <CircularProgress style={{margin: '0 5px'}} size={20}/> : null}
                                           {params.InputProps.endAdornment}
                                         </React.Fragment>
                                      ),
                                    }}
                         />}
                   />
                   {
                     validations?.newStateAndCityAgent &&
                     <p className="error">{validations?.newStateAndCityAgent}</p>
                   }
                 </div>
               </div>
               <div className="col-12 col-md-8">
                 <div className="input">
                   <label>{t("agencyRequest.t5")}</label>
                   <input type="text" name="addressAgent" id="addressAgent"
                          value={addressAgent} ref={ref20}
                          onChange={e => setAddressAgent(e.target.value)}/>
                   {
                     validations?.addressAgent &&
                     <p className="error">{validations?.addressAgent}</p>
                   }
                 </div>
               </div>
               <div className="col-12 col-md-6 col-lg-4">
                 <div className="input">
                   <label>{t("agencyRequest.t65")}</label>
                   <input type="text" name="postalCodeAgent" className="numeric"
                          value={postalCodeAgent} id="postalCodeAgent" ref={ref21}
                          onChange={e => e?.target?.value?.length <= 10 && setPostalCodeAgent(removeNonNumeric(e.target.value))}
                   />
                   {
                     validations?.postalCodeAgent &&
                     <p className="error">{validations?.postalCodeAgent}</p>
                   }
                 </div>
               </div>
               <div className="col-12 col-md-6 col-lg-4">
                 <div className="input">
                   <label>{t("agencyRequest.t7")}</label>
                   <input type="text" name="phoneNoAgent" className="numeric" inputMode='numeric' id="phoneNoAgent"
                          value={phoneNoAgent} ref={ref22}
                          onChange={e => e?.target?.value?.length <= 11 && setPhoneNoAgent(removeNonNumeric(e.target.value))}/>
                   {
                     validations?.phoneNoAgent &&
                     <p className="error">{validations?.phoneNoAgent}</p>
                   }
                 </div>
               </div>

               <Divider />

               <div className="col-12">
                 <h5>{t("agencyRequest.t67")}:</h5>
               </div>
               <div className="col-12 col-md-6 col-lg-4">
                 <label>{t("agencyRequest.t68")}</label>
                 <PatternFormat name="iban" id="iban" value={ibanNumber} valueIsNumericString format="IR## #### #### #### #### #### ##" ref={ref23}
                                onValueChange={(value) => setIbanNumber(value?.value)}
                                style={{direction: 'ltr'}}/>
                 {
                   validations?.ibanNumber &&
                   <p className="error">{validations?.ibanNumber}</p>
                 }
               </div>
               <div className="col-12 col-md-6 col-lg-4">
                 <label>{t("agencyRequest.t69")}</label>
                 <input type="text" name="accountNo" className="numeric" inputMode='numeric' id="accountNo"
                        value={accountNo} ref={ref24}
                        onChange={e => setAccountNo(removeNonNumeric(e.target.value))}/>
                 {
                   validations?.accountNo &&
                   <p className="error">{validations?.accountNo}</p>
                 }
               </div>
               <div className="col-12 col-md-6 col-lg-4">
                 <div className="input">
                   <label>{t("agencyRequest.t70")}</label>
                   <select aria-label="Default select example" value={bank} id="bank" ref={ref25}
                           onChange={e => setBank(e.target.value)}>
                     <option value="" selected disabled>{t("homeDesktop.s1.t4.tt10")}</option>
                     {
                       banks?.map(item => <option value={item?.code} key={item?.code}>{item?.name}</option>)
                     }
                   </select>
                   {
                     validations?.bank &&
                     <p className="error">{validations?.bank}</p>
                   }
                 </div>
               </div>
               <div className="col-12 col-md-6 col-lg-4">
                 <div className="input">
                   <label>{t("agencyRequest.t71")}</label>
                   <input type="text" name="branchName" id="branchName"
                          value={branchName} ref={ref26}
                          onChange={e => setBranchName(e.target.value)}/>
                   {
                     validations?.branchName &&
                     <p className="error">{validations?.branchName}</p>
                   }
                 </div>
               </div>

               <Divider />

               <div className="col-12">
                 <div className="input">
                   <label>{t("agencyRequest.t18")}</label>
                   <textarea rows="3" value={postalRecords} onChange={e => setPostalRecords(e.target.value)} id="postalRecords" ref={ref27}/>
                 </div>
               </div>
               <div className="col-12 col-md-6 col-lg-4">
                 <div className="input">
                   <label>{t("agencyRequest.t23")}</label>
                   <select aria-label="Default select example" value={acquaintance} id="acquaintance" ref={ref28}
                           onChange={e => setAcquaintance(e.target.value)}>
                     <option value="" selected disabled>{t("homeDesktop.s1.t4.tt10")}</option>
                       {acquaintances?.map(item => <option value={item?.code} key={item?.code}>{item?.title}</option>)}
                   </select>
                   {
                     validations?.acquaintance &&
                     <p className="error">{validations?.acquaintance}</p>
                   }
                 </div>
               </div>
               <div className="col-12 col-md-6 col-lg-4">
                 <div className="input">
                   <label>{t("agencyRequest.t33")}</label>
                   <input type="text" name="fleetCapacity" id="fleetCapacity"
                          value={fleetCapacity} ref={ref29}
                          onChange={e => setFleetCapacity(e.target.value)}/>
                   {
                     validations?.fleetCapacity &&
                     <p className="error">{validations?.fleetCapacity}</p>
                   }
                 </div>
               </div>
               <div className="col-12 col-md-6 col-lg-4 align-self-center">
                 <FormControlLabel control={<Checkbox checked={job} onChange={(e) => setJob(e.target.checked)} />} label={t("agencyRequest.t43")} />
               </div>

               <div className="col-12">
                 <div className="input">
                   <label>{t("agencyRequest.t45")}</label>
                   <textarea rows="5" value={desc} onChange={e => setDesc(e.target.value)} id="desc" ref={ref30}/>
                   {
                     validations?.desc &&
                     <p className="error">{validations?.desc}</p>
                   }
                 </div>
               </div>
               <div className="col-12 mb-4">
                 <p>{t("agencyRequest.t46")}</p>
               </div>
               <div className="col-12 col-md-6 pt-3">
                 <FormGroup>
                   <FormControlLabel control={<Checkbox checked={rules} id="rules" ref={ref31}
                                                        onChange={e => setRules(e.target.checked)}/>}
                                     label={t("agencyRequest.t44")}/>
                 </FormGroup>
                 {
                   validations?.rules &&
                   <p className="error">{validations?.rules}</p>
                 }
               </div>
               <div className="col-12 col-md-6">
                 <div className="btnGroup_yellow mb-0">
                   <button className="btnFill justify-content-center m-0" onClick={validationInput}
                           disabled={selector?.loading?.isLoading} >
                     {
                       selector?.loading?.isLoading ?
                          <Box sx={{display: 'flex'}}>
                            <CircularProgress size={20}/>
                          </Box>
                          :
                          <>
                            <span>{t("agencyRequest.t47")}</span>
                          </>
                     }
                   </button>
                 </div>
               </div>
             </div>
           </div>
         </div>
       </div>
     </>
  )
}
